var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { LeterPermissionType } from "../../../../../letrcore/src/Letr";
import { UserView as UserUI } from './UsersViewStore';
export class AdminAddMemberState {
    constructor() {
        this.open = false;
        this.adding = false;
        this.users = new Map();
        this.selectedusers = new Map();
        makeObservable(this);
    }
    clearAndSetusers(users) {
        this.users.clear();
        users.forEach((u) => this.users.set(u.id, u));
    }
    setOpen(open) {
        this.open = open;
        if (!open) {
            this.selectedusers.clear();
            this.setAdding(false);
        }
    }
    userSel(user, sel, modify) {
        if (sel) {
            const perm = {
                userid: user.id,
                permission: modify ? LeterPermissionType.Edit : LeterPermissionType.View,
                roleid: ''
            };
            this.selectedusers.set(user.id, perm);
        }
        else {
            this.selectedusers.delete(user.id);
        }
    }
    setAdding(adding) {
        this.adding = adding;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminAddMemberState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminAddMemberState.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminAddMemberState.prototype, "users", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminAddMemberState.prototype, "selectedusers", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminAddMemberState.prototype, "clearAndSetusers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminAddMemberState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UserUI, Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], AdminAddMemberState.prototype, "userSel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminAddMemberState.prototype, "setAdding", null);
